<template>
  <admin-wrapper :straight-title="additionalModuleName" :has-buttons="false" :moduleEnabler="moduleEnabler" />
</template>
<script>
import { get } from 'vuex-pathify';
import AdminWrapper from '@/components/AdminWrapper';
export default {
  name: 'ZDMLightingControl',
  components: {
    AdminWrapper,
  },
  computed: {
    additionalModuleName: get('admin/additionalModules.LIGHTING_CONTROL.verbose_name'),
    moduleEnabler() {
      return {
        name: 'lighting_control_module_enabled',
        straightText: this.additionalModuleName,
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.additionalModuleName }),
      };
    },
  },
};
</script>
